// Affichage des statuts de fenêtre (handoff, « Système de statuts ») : toujours couleur + glyphe +
// libellé, jamais la couleur seule. `token` nomme les variables CSS `--s-<token>` / `--s-<token>-bg`.
import type { WindowStatus } from './templates/index.ts';

export interface StatusDisplay {
  token: 'wait' | 'imm' | 'run' | 'end' | 'off';
  label: string;
  glyph: string;
  /** Rang de tri : en cours d'abord. */
  rank: number;
}

export const STATUS_DISPLAY: Record<WindowStatus, StatusDisplay> = {
  en_cours: { token: 'run', label: 'En cours', glyph: '●', rank: 0 },
  imminent: { token: 'imm', label: 'Imminent', glyph: '◔', rank: 1 },
  attente: { token: 'wait', label: 'Attente', glyph: '○', rank: 2 },
  termine: { token: 'end', label: 'Terminé', glyph: '✓', rank: 3 },
  hors_saison: { token: 'off', label: 'Hors saison', glyph: '–', rank: 4 },
};
